import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { FaReply } from "react-icons/fa";
import ImageDisplay from "../../../components/chat/ImageDisplay";
import { useInfoUser } from "../../../store/UserStore";
import { getFileIcon } from "../../../utils/SendFile";
import "./style.scss";
const QuotationResponse = ({ quotation, setQuotation }) => {
  const { user } = useInfoUser();

  if (!quotation) return;

  return (
    <div className="response bg-[#ebecf0] rounded-[5px] gap-2.5 m-[6px]">
      <div className="flex justify-between">
        <div className="flex items-center gap-[5px]">
          <FaReply />
          <div>Response</div>
          {quotation?.senderId !== user?.userId && (
            <div>{quotation?.username}</div>
          )}
        </div>
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={() => setQuotation(null)}
        />
      </div>
      {quotation?.contentType === "FILE" && (
        <div className="max-w-[240px] max-h-[300px] flex flex-row my-1 items-center">
          {quotation?.files?.[0]?.originalName
            ? getFileIcon(quotation?.files?.[0]?.originalName)
            : quotation?.files?.[0]?.originalName}
          {quotation?.files?.[0]?.originalName}
        </div>
      )}
      {quotation?.contentType === "IMAGE" && (
        <ImageDisplay
          resourceId={quotation?.photos[0]?.resourceId}
          classNameCss={"border h-[50px] w-[50px] background"}
        />
      )}
      {quotation?.contentType === "TEXT" && (
        <div>
          {quotation?.content
            ?.replace(/@\[([^\]]+)\]\([^)]+\)/g, "@$1")
            ?.split("\n")[0]
            ?.substring(0, 50)}
        </div>
      )}
    </div>
  );
};

export { QuotationResponse };
